import { Routes } from '@angular/router';

import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ResetPasswordComponent } from './reset-password.component';
import { ResetPasswordSuccessComponent } from './reset-password-success.component';

export const AuthRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login-help', component:  ForgotPasswordComponent },
  { path: 'reset-password', component:  ResetPasswordComponent },
  { path: 'reset-password-success', component:  ResetPasswordSuccessComponent }
];



/** WEBPACK FOOTER **
 ** ./app/authentication/auth.routes.ts
 **/